export { default as FacebookFeeds } from "./FacebookFeeds";
export { default as InstagramFeeds } from "./InstagramFeeds";
export { default as PinterestFeeds } from "./PinterestFeeds";
export { default as TwitterFeeds } from "./TwitterFeeds";
export { default as YoutubeFeeds } from "./YoutubeFeeds";
